if (!window.__pdpSizeHelpLinkBound) {
  window.__pdpSizeHelpLinkBound = true;

  /**
   * Devuelve el modal de la guía de tallas del producto, creándolo en <body> la primera vez
   * a partir del contenedor oculto que imprime snippets/pdp-size-help-link.liquid.
   * @param {string} productId
   * @returns {HTMLDialogElement | null}
   */
  const getSizeGuideDialog = (productId) => {
    const existing = document.body.querySelector(`:scope > dialog[data-size-guide-dialog="${productId}"]`);
    if (existing instanceof HTMLDialogElement) return existing;

    const source = document.querySelector(`[data-size-guide-template="${productId}"]`);
    if (!source) return null;

    const dialog = source.querySelector(`dialog[data-size-guide-dialog="${productId}"]`)?.cloneNode(true);
    if (!(dialog instanceof HTMLDialogElement)) return null;

    // Cerrar al pulsar fuera del panel (el backdrop cuenta como el propio <dialog>).
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-size-guide-close]')) dialog.close();
    });

    document.body.append(dialog);
    return dialog;
  };

  document.addEventListener('click', (event) => {
    const guideTrigger = event.target.closest('[data-size-guide-open]');
    if (guideTrigger) {
      const dialog = getSizeGuideDialog(guideTrigger.getAttribute('data-size-guide-open'));
      if (dialog && !dialog.open) {
        event.preventDefault();
        dialog.showModal();
        return;
      }
    }

    const trigger = event.target.closest('[data-size-help-target]');
    if (!trigger) return;

    const targetId = trigger.getAttribute('data-size-help-target');
    // Shopify prefija el id real del bloque con un hash interno (<hash>__<id-configurado>),
    // por eso se busca por sufijo en vez de una coincidencia exacta.
    const details = document.querySelector('[id$="' + targetId + '"]');
    if (!(details instanceof HTMLDetailsElement)) return;

    details.open = true;
    details.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}
